import React, { useState } from 'react'
import ImageBoxPagination from '../../../../component/imageDetail/imageBoxPagination'
import MainImage from '../mainImage'
import { TQueryParams } from '..'
import OtherOperation from './other'
import { IMAGE_DETAIL_TAB } from '../infoView'
import { ImageDetailContext } from '../content'
import styles from './index.module.less'

type toggleLabel = 1 | -1

export type OperationViewProps = {
    imgInfoList: Array<any>
    setImgInfoList:any,
    onChangeInnerIndex:(arg:number|string)=>void,
    innerIndex:any,
    queryParams: TQueryParams,
    onInit:()=>void,
    currentImage:any,
    onBanOperation:(arg:boolean)=>void,
    onOuterChange:(arg:number|string, toggleLabel:toggleLabel)=>void,
    outerMaxLength:number,
    outerIndex:number,
    tabValue: IMAGE_DETAIL_TAB,
    isAnnotate:boolean,
    onIsAnnotate:any,
}

export default ({
  imgInfoList,
  setImgInfoList,
  onChangeInnerIndex,
  queryParams,
  onInit,
  currentImage,
  onBanOperation,
  onOuterChange,
  outerMaxLength,
  outerIndex,
  tabValue,
  isAnnotate,
  onIsAnnotate,
  innerIndex,
}:OperationViewProps) => {
  const [showBox, setShowBox] = useState(localStorage.hideBoxVisible ? localStorage.hideBoxVisible === 'true' : true)
  const [showNoteLabel, setShowNoteLabel] = useState(localStorage.showNoteLabel ? localStorage.showNoteLabel === 'true' : true)
  const [scale, setScale] = useState(null)

  const onShowBox = (val) => {
    localStorage.hideBoxVisible = val
    setShowBox(val)
  }

  const onShowNoteLabel = (val) => {
    localStorage.showNoteLabel = val
    setShowNoteLabel(val)
  }
  return <div className={styles.mnImageDetailOperationView}>
    <div className={styles['img-actions']}>
      <div className={styles['action-pagination']}>
        <ImageBoxPagination
          imgInfoList={imgInfoList}
          setImgInfoList={setImgInfoList}
          onChangeInnerIndex={onChangeInnerIndex}
          collectId={queryParams.collectId}
          init={onInit}
          currentImage={currentImage}
        />
      </div>
      <MainImage
        content={ImageDetailContext}
        innerIndex={innerIndex}
        onChangeInnerIndex={onChangeInnerIndex}
        imgInfoList={imgInfoList}
        scale={scale}
        setScale={setScale}
        outerMaxLength={outerMaxLength}
        currentImage={currentImage}
        onBanOperation={onBanOperation}
        onOuterChange={onOuterChange}
        outerIndex={outerIndex}
        showNoteLabel={showNoteLabel}
        showBox={showBox}
      />
    </div>
    <OtherOperation
      scale={scale}
      setScale={setScale}
      tabValue={tabValue}
      currentImage={currentImage}
      showBox={showBox}
      showNoteLabel={showNoteLabel}
      onShowNoteLabel={onShowNoteLabel}
      onShowBox={onShowBox}
      imgInfoList={imgInfoList}
      sampleData={{}}
      isAnnotate={isAnnotate}
      onIsAnnotate={onIsAnnotate}
    />
  </div>
}
